import React, { Component } from "react";
import { BreadCumb, NewDocTable, NavBar, TimeOut } from "../../components";
import config from "../../config";
import moment from "moment";
import { ApiClient } from "../../libs/apiClient";
import { DISPATCH_ID, SERVICE_RESPONSE } from "../../libs/utils/Const";
import { connect } from "react-redux";
const apiClient = ApiClient.getInstance();
const today = moment(new Date()).format("YYYYMMDD");

const headers = [
    { title: "Serie", value: true },
    { title: "Estatus", value: true },
    { title: "Num.Doc", value: true },
    { title: "Cliente", value: true },
    { title: "Nombre", value: true },
    { title: "Fecha Cont.", value: true },
    { title: "Comentarios", value: true },
    { title: "Total", value: true },
]
class ProvConfAssistant extends Component {
    constructor(props) {
        super(props);
        this.state = {
            updateData: false,
            data: [],
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + "currentUser")),
        };
    }

    async componentDidMount() {
        const date = {
            dateInit: today,
            dateFinal: today,
        };

        await this.searchDocuments(date);
    }

    searchDocuments = async (newDate) => {
        const { enableSpinner, notificationReducer: {showAlert}} = this.props;
        let response = {};
        let documents = [];
        const data = {
            dateInit: newDate.dateInit,
            dateFinal: newDate.dateFinal,
            switch1: newDate.docStatus || "---",
            table: newDate.tableSearch || 'OPOR',
            docNumSearch: newDate.docNumSearch || "--",
        };

        enableSpinner(true);
        if(data.table !== 'OWOR'){
            response = await apiClient.getDocumentsList(data);
        }else{
            response = await apiClient.getDocumentsList_PROD(data);
        }
        enableSpinner(false);

        if (response.status === SERVICE_RESPONSE.SUCCESS) {
            documents = response.data;
        }else{
            showAlert({ type: 'info', message: response.message})
        }

        documents.unshift({table: data.table});
        this.setState({ data: documents });
    }

    render() {
        const { data, _user } = this.state;
        return (
            <div className="content">
                <NavBar props={this.props} _user={_user} />
                <BreadCumb subitem1={"ASISTENTE DE CONFIRMACIÓN DE APROVISIONAMIENTO"} url1={"#"} />
                <TimeOut />
                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>
                    <h2 className="md-display-1">
                        <a id="linkOrdProv" className="text-muted">
                            &nbsp;ASISTENTE DE CONFIRMACIÓN DE APROVISIONAMIENTO
                        </a>
                    </h2>
                    <NewDocTable
                        headers={headers}
                        view={"provConfAssistant"}
                        data={data}
                        search={this.searchDocuments}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (store) => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = (dispatch) => {
    return {
        enableSpinner: (value) => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value }),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProvConfAssistant);